<template>
  <section class="mt-3" id="chart">

    <b-row
      v-for="(chartOptions, chartIndex) in options"
      :key="chartIndex"
      class="mt-4">
      <b-col cols="6" sm="6" md="4">
        <apexchart type="pie" :options="chartOptions" :series="getSeriesByMu(chartOptions.mu)"></apexchart>
      </b-col>
      <b-col>
        <b-table striped hover :fields="getTableFieldsByMu(chartOptions.mu)"
                 :items="getTableDataByMu(chartOptions.mu)"></b-table>
      </b-col>
    </b-row>

  </section>
</template>

<script>
import Vue from 'vue'
import VueApexCharts from 'vue-apexcharts'
import NeedUpdateMixin from "../../NeedUpdateMixin";
import {cloneDeep} from 'lodash';

Vue.use(VueApexCharts)

Vue.component('apexchart', VueApexCharts)

const sum = (accumulator, currentValue) => accumulator + currentValue;

let instance = null

export default {
  name: 'PieChart',
  props: ['filter'],

  mixins: [NeedUpdateMixin],

  created() {
    instance = this
    this.reload()
  },

  data() {
    return {
      options: [],
      series: [],
      tableData: [],
      tableFields: [
        {key: 'name', sortable: true, label: 'Nome'},
        {key: 'perc', sortable: true, label: '%'},
        {key: 'value', sortable: true, label: ''}
      ],

      chartOption: {
        colors: this.$store.state.colors,
        labels: [],
        tooltip: {
          y: {
            formatter: (val) => {
              return this.$options.filters.formatDecimal(val)
            },
          },
        },
        legend: {
          position: 'bottom',
          itemMargin: {
            horizontal: 10,
            vertical: 5,
          },
          formatter: (seriesName, opts) => {
            return seriesName.split(',')[0]
          },
        },
        chart: {
          locales: this.getChartsLocales(),
          defaultLocale: "it",
          toolbar: {
            show: true,
            tools: {
              download: false,
              selection: true,
              zoom: true,
              zoomin: true,
              zoomout: true,
              pan: false,
              reset: '<img title="Reset zoom" src="/static/icons/icon-2.png" width="16">',
              customIcons: [{
                icon: '<img src="/static/icons/icon-6.png" width="16">',
                title: 'Visualizza costi',
                class: 'apex-custom-button volta-icon-euro',
                index: 0,
                click: function () {
                  instance.filter.costs = !instance.filter.costs
                  instance.reload()
                }
              }],
            }
          },
        }
      },
    }
  },

  watch: {
    filter() {
      _.debounce(this.reload, 10)();
    }
  },

  methods: {
    getSeriesByMu(mu) {
      const values = this.series.find((values) => values.mu === mu);

      return values ? values.values : [];
    },

    getTableDataByMu(mu) {
      const data = this.tableData.find((data) => data.mu === mu);

      return data ? data.data : [];
    },

    getTableFieldsByMu(mu) {
      const tableFields = cloneDeep(this.tableFields);
      const valueColumn = tableFields.find((field) => field.key === 'value');
      valueColumn.label = `[${mu}]`;

      return tableFields;
    },

    async reload() {
      if (this.loading) {
        return;
      }

      const options = [];
      const series = [];
      const tableDatas = [];

      if (this.filter.channels.length === 0) {
        this.options = options
        this.series = series;
        this.tableData = tableDatas;
        return;
      }

      this.$store.commit('loading');

      try {
        const data = await this.$store.dispatch('charts/get', this.filter);

        data.columns.forEach((columnName, i) => {
          if (i === 0) {
            return;
          }

          const mu = data.mus[i - 1];
          const label = `${columnName}, [${mu}]`;

          let chartOption = options.find((option) => option.mu === mu);

          if (!chartOption) {
            chartOption = cloneDeep(this.chartOption);
            chartOption.mu = mu;
            options.push(chartOption);
          }

          chartOption.labels.push(label);

          let value = 0
          data.values.forEach(v => {
            if (v[i]) {
              value += v[i];
            }
          })

          const chartByMuValues = series.find((values) => values.mu === mu);
          if (chartByMuValues) {
            chartByMuValues.values.push(value);
          } else {
            series.push({
              mu,
              values: [value]
            })
          }


          const newTableData = {
            name: columnName,
            perc: 0,
            value,
          };

          const tableData = tableDatas.find((tableData) => tableData.mu === mu);
          if (tableData) {
            tableData.total += value;
            tableData.data.push(newTableData);
          } else {
            tableDatas.push({
              mu,
              total: value,
              data: [newTableData],
            })
          }
        });

        tableDatas.forEach((tableData) => {
          tableData.data.forEach((data) => {
            // Calculate percent for each row
            const percent = data.value / tableData.total * 100;
            data.perc = `${percent.toFixed(2)}%`;

            // Format value
            data.value = this.$options.filters.formatDecimal(data.value);
          });

          // Add totals
          tableData.data.push({
            name: 'Total',
            perc: '100%',
            value: this.$options.filters.formatDecimal(tableData.total),
          });
        });

        this.tableData = tableDatas;
        this.options = options
        this.series = series;
      } finally {
        this.$store.commit('stopLoading');
      }
    }
  },
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Charts/Types/Apex/Pie.vue